/**
 * Short Answer Question Component
 */

import React, { useState } from 'react';
import { QuestionWithOptions } from '../../types/models';
import { MediaImage } from './MediaImage';

interface ShortAnswerQuestionProps {
  question: QuestionWithOptions;
  textResponse?: string;
  onChange: (textResponse: string) => void;
  showFeedback?: boolean;
  isCorrect?: boolean;
  explanation?: string;
}

export const ShortAnswerQuestion: React.FC<ShortAnswerQuestionProps> = ({
  question,
  textResponse = '',
  onChange,
  showFeedback = false,
  isCorrect,
  explanation,
}) => {
  const [value, setValue] = useState(textResponse);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setValue(newValue);
    onChange(newValue);
  };

  let inputClassName = '';
  if (showFeedback) {
    inputClassName = isCorrect ? 'correct' : 'incorrect';
  }

  return (
    <div className="question short-answer">
      <h3>{question.prompt_text}</h3>
      {question.prompt_media_url && (
        <MediaImage
          src={question.prompt_media_url}
          alt="Question media"
          width={question.prompt_media_width}
          height={question.prompt_media_height}
        />
      )}
      <div className="input-container">
        <input
          type="text"
          value={value}
          onChange={handleChange}
          disabled={showFeedback}
          placeholder="Enter your answer"
          className={inputClassName}
        />
      </div>
      {showFeedback && (
        <div className="feedback">
          {isCorrect ? (
            <span className="correct-indicator">✓ Correct</span>
          ) : (
            <span className="incorrect-indicator">✗ Incorrect</span>
          )}
          {explanation && <div className="explanation">{explanation}</div>}
        </div>
      )}
    </div>
  );
};
